module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "aboutAuthorPage",
    attrs: {
      "id": "ata01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page05"
    }
  }, [_c('h2', {
    staticClass: "aboutAuthorHead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("All about the author…"), _c('br'), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jennie Lucas")])])]), _vm._v(" "), _c('p', {
    staticClass: "aboutAuthorText"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("JENNIE LUCAS")]), _vm._v(" had a tragic beginning for any would-be writer: a very happy childhood. Her parents owned a bookstore, and she grew up surrounded by books, dreaming about faraway lands. When she was ten, her father secretly paid her a dollar for every classic novel ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jane Eyre, War and Peace")]), _vm._v(") that she read.")]), _vm._v(" "), _c('p', {
    staticClass: "aboutAuthorText"
  }, [_vm._v("At fifteen, she went to a Connecticut boarding school on scholarship. She took her first solo trip to Europe at sixteen, then put off college and traveled around the U.S., supporting herself with jobs as diverse as gas-station cashier and newspaper advertising assistant.")]), _vm._v(" "), _c('p', {
    staticClass: "aboutAuthorText"
  }, [_vm._v("At twenty-two, she met the man who would be her husband. For the first time in her life, she wanted to stay in one place, as long as she could be with him. After their marriage, she graduated from Kent State University with a degree in English, and started writing books a year later.")]), _vm._v(" "), _c('p', {
    staticClass: "aboutAuthorText"
  }, [_vm._v("Jennie was a finalist in the Romance Writers of America’s Golden Heart contest in 2003 and won the award in 2005. A fellow 2003 finalist, Australian author Trish Morey, read Jennie’s writing and told her that she should write for the Harlequin Presents"), _c('sup', [_vm._v("®")]), _vm._v(" line. It seemed like too big a dream, but Jennie took a deep breath and went for it. A year later Jennie got the magical call from London that turned her into a published author.")]), _vm._v(" "), _c('p', {
    staticClass: "aboutAuthorText"
  }, [_vm._v("Since then, life has been hectic—juggling a writing career, a sexy husband and two young children—but Jennie loves her crazy, chaotic life. Now if she could only figure out how to pack up her family and live in all the places she’s writing about!")]), _vm._v(" "), _c('p', {
    staticClass: "aboutAuthorText"
  }, [_vm._v("For more about Jennie and her books, please visit her Web site at www.jennielucas.com.")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page05"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e2d6210","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/boughtthegreeksbaby_ata01.vue
// module id = 66
// module chunks = 0